(function () {
  var KEY = 'sf_wishlist';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  }
  function toggle(handle) {
    var list = get(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    save(list);
  }
  function sync() {
    var list = get();
    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-handle')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== String(list.length)) el.textContent = list.length;
    });
  }

  // Works for dynamically loaded cards too (infinite scroll, filters, quick view)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-wishlist-handle'));
  });

  document.addEventListener('DOMContentLoaded', sync);

  // Re-sync when new product cards are injected
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-wishlist-handle]') || n.querySelector('[data-wishlist-handle]'))) {
          return sync();
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  window.SFWishlist = { get: get, toggle: toggle, sync: sync };
})();